<template>
  <b-modal
    :id="modalId"
    :title="currentTitle"
    name="create-folder-modal"
    ref="createfoldermodal"
    size="lg"
    :busy="loading"
    ok-title="Create"
    :ok-disabled="!folderName || errors.has('name')"
    close-title="Cancel"
    hide-header-close
    @ok="handleOk"
    @keydown.native.enter="handleOk">
    <form id="create-folder-form">
      <div class="form-group">
        <b-form-input v-model="folderName"
                      type="text"
                      placeholder="Folder name"
                      data-vv-name="name"
                      v-validate="{ required: true, max: 100, regex: /^[^\\]+$/ }">
        </b-form-input>
        <icon v-show="errors.has('name')" name="warning"></icon>
        <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
      </div>
      <span v-if="currentProject && !parentFolderId">This will be added to the root of project <strong>{{ currentProject.name }}</strong></span>
      <span v-if="currentProject && parentFolderId">This will be added to the project <strong>{{ currentProject.name }}</strong></span>
    </form>
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Creating
    </div>
  </b-modal>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      },
      currentTitle () {
        return this.parentFolderId ? 'Create a child folder' : 'Create a folder'
      }
    },
    data () {
      return {
        folderName: '',
        loading: false
      }
    },
    props: {
      modalId: String,
      parentFolderId: {
        default: null,
        type: Number
      }
    },
    mixins: [utilsMixin],
    methods: {
      handleOk (e) {
        e.preventDefault()
        // This validateAll is needed for the case when nothing has been entered yet
        // Otherwise it was letting it validate
        // The empty then/catch avoids a console error
        this.$validator.validateAll().then(() => {
        }).catch(() => {
        })
        if (this.errors.any()) {
          return e.cancel()
        } else {
          this.loading = true
          this.submitData()
        }
      },
      clearModal () {
        this.folderName = ''
        this.loading = false
        this.$nextTick(() => {
          this.errors.clear()
        })
      },
      submitData () {
        this.$ga.event('folder', 'create', this.folderName, 1)
        this.$http.post(
          '/api/folder',
          {
            name: this.folderName,
            parent_folder_id: this.parentFolderId,
            project: this.currentProject
          }
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Folder created successfully',
            type: 'success',
            close: 'auto'
          })
          this.clearModal()
          this.setTheState()
          this.$refs.createfoldermodal.hide()
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem saving your folder: ${errorString}`,
            type: 'error'
          })
          this.loading = false
        })
      },
      setTheState () {
        this.$store.commit('setNeedToRefreshItemsList', true)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// CreateFolderModal.vue?dc833d4e